/* eslint-disable no-use-before-define */
import { ajax, getState, publish } from '../../twd'


getState('municipals.market-news.use-bitvore', {
    token:'',
    expired: 0
})

export const getAuth = async () => {
    try {
        let state = getState('municipals.market-news.use-bitvore')
        let { token, expired } = state.value
        let now = Date.now()
        if (token && expired > now) {
            return { Authorization: 'Bearer ' + token }
        }

        let { data } = ajax({
            url: '/esb/retailservice/bitvoreNewsAPIService/getAccessTokenByAPIType',
            method: 'POST',
            params: { bondType: 'MUNI' }
        })

        let a = await data
        if (!a.access_token) {
            throw new Error('no access token')
        }

        state.set({
            token: a.access_token,
            expired: now + (a.expires_in * 1000)
        })

        publish('municipals-market-news-unavailable', false)

        return { Authorization: 'Bearer ' + state.value.token }
    }
    catch(x) {
        publish('municipals-market-news-unavailable', true)
    }
}



// WEBPACK FOOTER //
// ./src/municipals/market-news/use-bitvore.js